import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IEventData } from "common/records/Event";
import { IdType } from "common/types";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";

export const RECEIVE_EVENTS = "@appointments/RECEIVE_EVENTS";
export const FETCH_EVENT = "@appointments/FETCH_EVENT";
export const RECEIVE_EVENT = "@appointments/RECEIVE_EVENT";
export const REMOVE_EVENT = "@appointments/REMOVE_EVENT";
export const RESET_EVENT = "@events/RESET_EVENT";

export const EventActions = {
  receiveEvents: (events: Partial<IEventData>[]) => createAction(RECEIVE_EVENTS, { events }),
  fetchEvent: (eventId: number) => createAction(FETCH_EVENT, { eventId }),
  receiveEvent: (event: Partial<IEventData>) => createAction(RECEIVE_EVENT, { event }),
  removeEvent: (eventId: IdType) => createAction(REMOVE_EVENT, { eventId }),
  resetEvent: (eventId: number) => createAction(RESET_EVENT, { eventId }),
};

export type EventActions = ActionsUnion<typeof EventActions>;
